/* ============================================================================
   Glassy Prescription Menu — guided 3-step builder
   ----------------------------------------------------------------------------
   Steps: 1) Lens  2) Prescription (Upload → auto-read via the OCR endpoint, or
   Enter manually) + PD (camera measurer or known)  3) Review → Add to cart.

   On "Add to cart" we submit ONE atomic /cart/add sequence:
     • the frame (multipart, so an uploaded Rx photo attaches to the line), plus
     • a companion "Prescription Lenses" line (the priced upcharge) carrying the
       Rx as line-item properties.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__glassyRxLoaded) return;
  window.__glassyRxLoaded = true;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function tv() { return window.themeVariables || {}; }
  function cartAddUrl() { var t = tv(); return (t.routes && t.routes.cartAddUrl ? t.routes.cartAddUrl : root() + 'cart/add') + '.js'; }
  function cartUrl() { var t = tv(); return (t.routes && t.routes.cartUrl ? t.routes.cartUrl : root() + 'cart') + '.js'; }
  function cartType() { var t = tv(); return (t.settings && t.settings.cartType) || 'page'; }
  function isPageCart() { var t = tv(); return cartType() === 'page' || (t.settings && t.settings.pageType) === 'cart'; }

  function money(cents) {
    var cc = (tv().settings && tv().settings.cartCurrency) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cc }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function addOnPrice(cents) { return cents > 0 ? '+' + money(cents) : 'Included'; }

  /* ---- Diopter option lists ---- */
  function range(from, to, step, signed, decimals) {
    var out = [], count = Math.round((to - from) / step);
    for (var i = 0; i <= Math.abs(count); i++) {
      var v = from + (count >= 0 ? 1 : -1) * step * i, label = v.toFixed(decimals);
      if (signed && v > 0) label = '+' + label;
      out.push(label);
    }
    return out;
  }
  var SPH = range(6, -12, 0.25, true, 2);
  var CYL = range(6, -6, 0.25, true, 2);
  var ADD = range(0.75, 3, 0.25, true, 2); ADD.unshift('0.00');
  var AXIS = (function () { var a = ['0']; for (var i = 1; i <= 180; i++) a.push(String(i)); return a; })();
  function options(values, def) {
    var html = '';
    for (var i = 0; i < values.length; i++) { var v = String(values[i]); html += '<option value="' + v + '"' + (v === String(def) ? ' selected' : '') + '>' + v + '</option>'; }
    return html;
  }
  function populateSelect(sel) {
    var k = sel.getAttribute('data-rx-select');
    if (k === 'sph') sel.innerHTML = options(SPH, '0.00');
    else if (k === 'cyl') sel.innerHTML = options(CYL, '0.00');
    else if (k === 'axis') sel.innerHTML = options(AXIS, '0');
    else if (k === 'add') sel.innerHTML = options(ADD, '0.00');
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // Lens thickness (high-index) — maps the prescription-lenses product's 2nd option to friendly copy.
  // 1.74 was retired (Empire Optical doesn't offer 1.74 polarized, and it kept the menu in sync with
  // the lab catalog): only Standard (poly) and Thin (1.67) ship now.
  var THICK_META = {
    standard: { label: 'Standard', desc: 'Polycarbonate · everyday wear' },
    thin: { label: 'Thin — high-index 1.67', desc: 'Noticeably thinner & lighter' }
  };
  var THICK_ORDER = ['standard', 'thin'];
  function thickKey(o2) { var s = (o2 || '').toLowerCase(); if (s.indexOf('1.67') >= 0) return 'thin'; return 'standard'; }
  function typeKey(o1) {
    var s = (o1 || '').toLowerCase();
    if (s.indexOf('polar') >= 0) return 'polarized';
    if (s.indexOf('blue') >= 0 || s.indexOf('gaming') >= 0) return 'blue-light';
    if (s.indexOf('reader') >= 0 || s.indexOf('anti-reflective') >= 0 || s.indexOf('anti reflective') >= 0) return 'readers';
    return s.trim();
  }

  // Normalise an OCR dioptre string to a matching option value ("+0.50" / "-1.25" / "0.00").
  function fmtDioptre(v) {
    if (v == null) return null;
    var s = String(v).trim().toLowerCase();
    if (s === '' || s === 'plano' || s === 'pl' || s === 'ds') return '0.00';
    var n = parseFloat(s.replace(/[^0-9.+-]/g, ''));
    if (isNaN(n)) return null;
    if (n === 0) return '0.00';
    var out = Math.abs(n).toFixed(2);
    return (n > 0 ? '+' : '-') + out;
  }
  function fmtAxis(v) { if (v == null) return '0'; var n = parseInt(v, 10); if (isNaN(n)) return '0'; if (n < 0) n = 0; if (n > 180) n = 180; return String(n); }

  // Downscale an image file to a JPEG data URL (handles big iPhone photos + HEIC via <img>). PDFs → null (no OCR).
  function fileToJpegDataUrl(file) {
    return new Promise(function (resolve) {
      if (!/^image\//.test(file.type)) { resolve(null); return; }
      var img = new Image(), url = URL.createObjectURL(file);
      img.onload = function () {
        URL.revokeObjectURL(url);
        var max = 1600, w = img.naturalWidth, h = img.naturalHeight, scale = Math.min(1, max / Math.max(w, h));
        var cw = Math.max(1, Math.round(w * scale)), ch = Math.max(1, Math.round(h * scale));
        var c = document.createElement('canvas'); c.width = cw; c.height = ch;
        c.getContext('2d').drawImage(img, 0, 0, cw, ch);
        try { resolve(c.toDataURL('image/jpeg', 0.85)); } catch (e) { resolve(null); }
      };
      img.onerror = function () { URL.revokeObjectURL(url); resolve(null); };
      img.src = url;
    });
  }

  /* ---- Instance ---- */
  function GlassyRx(el) {
    this.root = el;
    this.form = document.getElementById(el.getAttribute('data-form-id'));
    this.busy = false; this.step = 0; this.readDone = false;
    this.init();
  }

  GlassyRx.prototype.init = function () {
    var self = this;
    // 'always'  = open on load, native ATC hidden, builder is the only path (eyeglasses).
    // 'optional' = collapsed under a secondary button, native ATC stays primary (sun/gaming).
    this.mode = this.root.getAttribute('data-rx-mode') || 'always';
    this.root.querySelectorAll('[data-rx-select]').forEach(populateSelect);
    this.priceTargets = this.collectPriceTargets();

    this.q('[data-rx-drawer]', function (b) { b.addEventListener('click', function () { self.toggleDrawer(); }); });
    this.root.querySelectorAll('[data-rx-close]').forEach(function (b) { b.addEventListener('click', function () { self.setOpen(false); }); });
    this.root.querySelectorAll('[data-rx-lens]').forEach(function (i) { i.addEventListener('change', function () { self.updatePrice(); self.updateReview(); self.goToStep(self.step); }); });
    var file = this.root.querySelector('[data-rx-file]'); if (file) file.addEventListener('change', function () { self.onOcrFile(); });
    // Open the file picker via an explicit click — reliable on iOS Safari, unlike a
    // <label> wrapping a hidden file input (which often silently fails to open there).
    this.root.querySelectorAll('[data-rx-pick]').forEach(function (el) { el.addEventListener('click', function () { var f = self.root.querySelector('[data-rx-file]'); if (f) { f.disabled = false; f.click(); } }); });
    // Drag-and-drop onto the main zone: the dropped file is put into the input so it
    // both feeds the OCR read and rides on the cart line.
    this.q('[data-rx-dropzone]', function (dz) {
      ['dragenter', 'dragover'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); dz.classList.add('is-dragover'); }); });
      ['dragleave', 'dragend'].forEach(function (ev) { dz.addEventListener(ev, function (e) { e.preventDefault(); e.stopPropagation(); if (ev === 'dragend' || !(e.relatedTarget && dz.contains(e.relatedTarget))) dz.classList.remove('is-dragover'); }); });
      dz.addEventListener('drop', function (e) {
        e.preventDefault(); e.stopPropagation(); dz.classList.remove('is-dragover');
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (!f) return;
        var input = self.root.querySelector('[data-rx-file]'); if (!input) return;
        input.disabled = false;
        try { var dt = new DataTransfer(); dt.items.add(f); input.files = dt.files; } catch (err) { return; }
        self.onOcrFile();
      });
    });
    this.root.querySelectorAll('[data-rx-pd-finder]').forEach(function (b) { b.addEventListener('click', function () { self.openPdFinder(); }); });
    var pd = this.root.querySelector('[data-rx-pd]'); if (pd) pd.addEventListener('input', function () { pd.classList.remove('glassy-rx__pd-input--needed'); self.updateReview(); self.updateNextState(); });
    this.root.querySelectorAll('[data-rx-select]').forEach(function (s) { s.addEventListener('change', function () { s.classList.remove('glassy-rx__select--flag'); self.updateAxisRequirement(); self.updateAddWarning(); self.updateReview(); self.updateNextState(); }); });
    this.q('[data-rx-addwarn-check]', function (c) { c.addEventListener('change', function () { if (c.checked) self.q('[data-rx-addwarn]', function (w) { w.classList.remove('glassy-rx__addwarn--needed'); }); self.hideError(); self.updateReview(); self.updateNextState(); }); });
    this.q('[data-rx-back]', function (b) { b.addEventListener('click', function () { self.onBack(); }); });
    this.q('[data-rx-next]', function (b) { b.addEventListener('click', function () { self.onNext(); }); });

    this.pdModal = this.root.querySelector('[data-rx-pd-modal]');
    this.pdFrame = this.root.querySelector('[data-rx-pd-frame]');
    if (this.pdModal && this.pdModal.parentElement !== document.body) document.body.appendChild(this.pdModal);
    if (this.pdModal) this.pdModal.querySelectorAll('[data-rx-pd-close]').forEach(function (el) { el.addEventListener('click', function () { self.closePdFinder(); }); });

    if (this.form) this.form.addEventListener('variant:changed', this._onVariant.bind(this));

    this.variants = this.parseVariants();
    this.buildThickness();
    this.updateFileInput(); this.updatePrice(); this.goToStep(0);
    if (this.mode === 'always') {
      // Prescription products: the builder replaces the native ATC and opens on load.
      this.hideNativeBuyButtons();
      this.setOpen(true);
    } else {
      // Optional: keep the native ATC as the primary path; builder starts collapsed.
      this.setOpen(false);
    }
  };

  /* ---- Lens thickness (high-index) ---- */
  GlassyRx.prototype.parseVariants = function () {
    var el = this.root.querySelector('[data-rx-variants]'); if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  };
  // Flat upcharge for a thickness key = (that variant's price) − (same type's Standard price).
  GlassyRx.prototype.thickDelta = function (k) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i]; if (thickKey(v.o2) !== k) continue; var t = typeKey(v.o1);
      for (var j = 0; j < this.variants.length; j++) { var s = this.variants[j]; if (typeKey(s.o1) === t && thickKey(s.o2) === 'standard') return v.price - s.price; }
    }
    return 0;
  };
  GlassyRx.prototype.buildThickness = function () {
    var self = this, cont = this.root.querySelector('[data-rx-thickness]'); if (!cont) return;
    var present = {}; this.variants.forEach(function (v) { present[thickKey(v.o2)] = true; });
    var keys = THICK_ORDER.filter(function (k) { return present[k]; });
    if (keys.length <= 1) { cont.hidden = true; return; }  // no upgrade offered → behaves exactly as before
    var name = (this.root.getAttribute('data-form-id') || 'glx') + '-thick';
    var html = '<div class="glassy-rx__thick-h">Lens thickness</div><div class="glassy-rx__thicks">';
    keys.forEach(function (k, i) {
      var m = THICK_META[k] || { label: k, desc: '' }, d = self.thickDelta(k);
      html += '<label class="glassy-rx__thick"><input type="radio" name="' + name + '" value="' + k + '" data-rx-thick' + (i === 0 ? ' checked' : '') + ' hidden>' +
        '<span class="glassy-rx__thick-card"><span class="glassy-rx__thick-t"><span class="glassy-rx__thick-name">' + escapeHtml(m.label) + '</span><span class="glassy-rx__thick-desc">' + escapeHtml(m.desc) + '</span></span>' +
        '<span class="glassy-rx__thick-price">' + (d > 0 ? '+' + escapeHtml(money(d)) : 'Included') + '</span></span></label>';
    });
    html += '</div>';
    cont.innerHTML = html; cont.hidden = false;
    cont.querySelectorAll('[data-rx-thick]').forEach(function (r) { r.addEventListener('change', function () { self.updatePrice(); self.updateReview(); self.goToStep(self.step); }); });
  };
  GlassyRx.prototype.selectedThick = function () { var r = this.root.querySelector('[data-rx-thick]:checked'); return r ? r.value : 'standard'; };
  GlassyRx.prototype.thickLabel = function () { var k = this.selectedThick(); if (k === 'standard') return ''; var m = THICK_META[k]; return m ? m.label : k; };
  // Resolve the exact companion variant for the chosen (type × thickness).
  GlassyRx.prototype.resolveVariant = function () {
    var lens = this.selectedLens(); if (!lens) return null;
    var tk = lens.getAttribute('data-rx-keyword'), thk = this.selectedThick(), i;
    if (tk === 'gaming') tk = 'blue-light';
    for (i = 0; i < this.variants.length; i++) { var v = this.variants[i]; if (typeKey(v.o1) === tk && thickKey(v.o2) === thk) return v; }
    for (i = 0; i < this.variants.length; i++) { var v2 = this.variants[i]; if (typeKey(v2.o1) === tk) return v2; }  // fallback: same type, first variant
    return null;
  };
  GlassyRx.prototype.q = function (sel, fn) { var e = this.root.querySelector(sel); if (e) fn(e); };

  // On eyeglasses the ONLY path to cart is the prescription flow (which ends in its own
  // "Add to cart"). Hide the native Add-to-cart + dynamic "Buy now", and turn the sticky
  // bar's button into an "Add your prescription" trigger so it can't bypass the flow.
  // The sticky trigger shows only while the builder is closed — once it's open (options
  // visible) the button is hidden (see syncStickyButton, driven by setOpen).
  GlassyRx.prototype.hideNativeBuyButtons = function () {
    var self = this;
    var buyBtns = this.form && this.form.closest('.product-form__buy-buttons');
    if (buyBtns) { var pc = buyBtns.querySelector('.product-form__payment-container'); if (pc) pc.style.display = 'none'; }
    var sticky = document.getElementById('StickyAddToCart');
    if (sticky) {
      sticky.type = 'button';
      sticky.textContent = 'Add your prescription';
      sticky.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        self.setOpen(true);
        self.root.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, true);
      this.stickyBtnWrap = sticky.closest('.product-sticky-form__form') || sticky.closest('.product-sticky-form__payment-container') || sticky;
      this.syncStickyButton();
    }
  };
  // Show the sticky "Add your prescription" trigger only when the builder is closed.
  GlassyRx.prototype.syncStickyButton = function () {
    if (this.stickyBtnWrap) this.stickyBtnWrap.style.display = this.isOn() ? 'none' : '';
  };

  /* ---- Stepper ---- */
  GlassyRx.prototype.goToStep = function (n) {
    this.step = n;
    this.root.querySelectorAll('[data-rx-screen]').forEach(function (s) { s.hidden = (+s.getAttribute('data-rx-screen') !== n); });
    this.root.querySelectorAll('.glassy-rx__prog i').forEach(function (i) { i.classList.toggle('on', +i.getAttribute('data-p') <= n); });
    this.q('[data-rx-stepnum]', function (e) { e.textContent = 'Step ' + (n + 1) + ' of 3'; });
    this.q('[data-rx-back]', function (b) { b.hidden = (n === 0); b.disabled = (n === 0); });
    var self = this;
    this.q('[data-rx-next]', function (b) { b.textContent = n === 2 ? ('Add to cart · ' + money(self.frameCents() + self.lensCents())) : 'Continue'; });
    if (n === 2) this.updateReview();
    this.updateNextState();
    this.hideError();
  };
  GlassyRx.prototype.onBack = function () { if (this.step > 0) this.goToStep(this.step - 1); };
  GlassyRx.prototype.onNext = function () {
    if (this.busy) return;
    if (this.step < 2) { if (this.validateStep(this.step)) this.goToStep(this.step + 1); return; }
    if (!this.validateStep(1)) { this.goToStep(1); return; }
    var self = this; this.busy = true; this.setBusy(true);
    Promise.resolve(this.addToCart()).then(function () { self.busy = false; self.setBusy(false); });
  };
  GlassyRx.prototype.validateStep = function (n) {
    if (n === 0) { if (!this.selectedLens()) { this.showError('Choose a lens.'); return false; } return true; }
    if (n === 1) {
      if (!this.readDone) { this.showError('Upload a photo of your prescription to continue.'); return false; }
      var eyes = [['od', 'right'], ['os', 'left']];
      for (var i = 0; i < eyes.length; i++) {
        var cyl = this.sel('cyl', eyes[i][0]), axis = this.sel('axis', eyes[i][0]);
        if (cyl && cyl.value && cyl.value !== '0.00' && axis && (!axis.value || axis.value === '0')) {
          this.updateAxisRequirement();
          this.showError('Enter the Axis for your ' + eyes[i][1] + ' eye (a CYL value needs an axis 1–180).'); return false;
        }
      }
      if (!this.addConfirmed()) {
        var w = this.root.querySelector('[data-rx-addwarn]');
        if (w) { w.classList.add('glassy-rx__addwarn--needed'); w.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        this.showError('Please check the box to confirm single-vision lenses.'); return false;
      }
      var pd = this.root.querySelector('[data-rx-pd]'), v = pd ? pd.value.trim() : '', num = parseFloat(v);
      if (!v || isNaN(num) || num < 40 || num > 85) {
        if (pd) { pd.classList.add('glassy-rx__pd-input--needed'); pd.scrollIntoView({ block: 'center', behavior: 'smooth' }); try { pd.focus(); } catch (e) {} }
        this.showError('Add your PD to continue — enter it, or tap “Find my PD” to measure it.'); return false;
      }
      if (pd) pd.classList.remove('glassy-rx__pd-input--needed');
      return true;
    }
    return true;
  };

  // Side-effect-free validity (no errors/flags) — drives the Continue button state.
  GlassyRx.prototype.stepValid = function (n) {
    if (n === 0) return !!this.selectedLens();
    if (n === 1) {
      if (!this.readDone) return false;
      for (var i = 0; i < 2; i++) {
        var eye = i ? 'os' : 'od', cyl = this.sel('cyl', eye), axis = this.sel('axis', eye);
        if (cyl && cyl.value && cyl.value !== '0.00' && axis && (!axis.value || axis.value === '0')) return false;
      }
      if (!this.addConfirmed()) return false;
      var pd = this.root.querySelector('[data-rx-pd]'), v = pd ? pd.value.trim() : '', num = parseFloat(v);
      if (!v || isNaN(num) || num < 40 || num > 85) return false;
      return true;
    }
    return true;
  };
  GlassyRx.prototype.updateNextState = function () {
    if (this.busy) return;
    var valid = this.stepValid(this.step);
    this.q('[data-rx-next]', function (b) { b.disabled = !valid; });
  };

  /* ---- OCR upload ---- */
  GlassyRx.prototype.onOcrFile = function () {
    var self = this, input = this.root.querySelector('[data-rx-file]'), file = input && input.files && input.files[0];
    if (!file) return;
    this.hideError();
    var start = this.root.querySelector('[data-rx-upload-start]'), reading = this.root.querySelector('[data-rx-upload-reading]'),
        done = this.root.querySelector('[data-rx-upload-done]'), table = this.root.querySelector('[data-rx-table]');
    // Show the spinner the INSTANT a photo is chosen — decoding a big iPhone photo
    // can take a few seconds, so we can't wait until after the downscale.
    start.hidden = true; reading.hidden = false; done.hidden = true;
    // Any upload reveals the editable table (pre-filled if we could read it) — the
    // shopper never gets stranded, but they also can't fill it in without a photo first.
    // `failed` = the auto-read produced nothing: swap the green "uploaded" bar for a
    // warning one and scroll to the table so manual entry is the obvious next step.
    function reveal(failed) {
      reading.hidden = true; done.hidden = false; self.readDone = true; if (table) table.hidden = false;
      var bar = self.root.querySelector('[data-rx-donebar]');
      if (bar) {
        bar.classList.toggle('glassy-rx__confirmbar--warn', !!failed);
        var ck = bar.querySelector('.glassy-rx__ck'); if (ck) ck.textContent = failed ? '!' : '✓';
        var t = bar.querySelector('[data-rx-done-title]'); if (t) t.textContent = failed ? 'We couldn’t read your file' : 'Prescription uploaded';
        var s = bar.querySelector('[data-rx-done-sub]'); if (s) s.textContent = failed ? 'Enter your prescription below — your file still comes with your order.' : 'Check the values below.';
      }
      self.q('[data-rx-flaghint]', function (h) { h.hidden = true; h.textContent = ''; }); // fillFromOcr re-sets it if fields need checking
      if (failed && table) table.scrollIntoView({ block: 'center', behavior: 'smooth' });
      self.updateReview(); self.updateNextState();
    }
    fileToJpegDataUrl(file).then(function (dataUrl) {
      if (!dataUrl) { reveal(true); return; } // PDF etc. — no OCR
      return fetch(self.root.getAttribute('data-ocr-url'), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ image: dataUrl }) })
        .then(function (r) { return r.json(); })
        .then(function (json) {
          if (!json || json.error || (!json.od && !json.os)) { reveal(true); return; }
          reveal(false); self.fillFromOcr(json);
        });
    }).catch(function () { reveal(true); });
  };

  GlassyRx.prototype.sel = function (kind, eye) { return this.root.querySelector('[data-rx-select="' + kind + '"][data-eye="' + eye + '"]'); };

  GlassyRx.prototype.fillFromOcr = function (json) {
    var self = this, flagged = {}, labels = [];
    function flag(kind, eye) {
      var key = eye + '.' + kind; if (flagged[key]) return; flagged[key] = 1;
      var s = self.sel(kind, eye); if (s) s.classList.add('glassy-rx__select--flag');
      labels.push((eye === 'od' ? 'Right' : 'Left') + ' ' + kind.toUpperCase());
    }
    ['od', 'os'].forEach(function (eye) {
      var e = json[eye] || {}, map = { sph: e.sph, cyl: e.cyl, axis: e.axis, add: e.add };
      ['sph', 'cyl', 'axis', 'add'].forEach(function (kind) {
        var s = self.sel(kind, eye); if (!s) return;
        s.classList.remove('glassy-rx__select--flag');
        var want = kind === 'axis' ? fmtAxis(map[kind]) : fmtDioptre(map[kind]);
        if (want == null) {
          // No ADD on the Rx is normal (single vision) — accept it as 0.00 rather than
          // flagging it. A missing SPH/CYL/Axis is genuinely suspicious, so those still flag.
          if (kind === 'add') { s.value = '0.00'; return; }
          flag(kind, eye); return;
        }
        s.value = want;
        if (s.value !== want) flag(kind, eye); // no matching option (e.g. plus-cyl notation)
      });
    });
    (json.unclear || []).forEach(function (u) {
      u = String(u).toLowerCase();
      ['od', 'os'].forEach(function (eye) {
        var words = [eye, eye === 'od' ? 'right' : 'left'];
        ['sph', 'cyl', 'axis', 'add'].forEach(function (kind) {
          if (u.indexOf(kind) >= 0 && words.some(function (w) { return u.indexOf(w) >= 0; })) flag(kind, eye);
        });
      });
    });
    var pdVal = json.pd != null ? json.pd : ((json.pd_od != null && json.pd_os != null) ? (parseFloat(json.pd_od) + parseFloat(json.pd_os)) : null);
    if (pdVal != null && isFinite(pdVal)) {
      var pd = this.root.querySelector('[data-rx-pd]'); if (pd) { pd.value = String(Math.round(pdVal)); pd.classList.remove('glassy-rx__pd-input--needed'); }
    }
    this.q('[data-rx-flaghint]', function (h) {
      if (labels.length) { h.hidden = false; h.textContent = '⚠ Please double-check ' + labels.join(', ') + ' against your Rx.'; }
      else { h.hidden = true; h.textContent = ''; }
    });
    this.updateAxisRequirement(); this.updateAddWarning(); this.updateReview(); this.updateNextState();
  };

  GlassyRx.prototype.updateAxisRequirement = function () {
    var self = this;
    ['od', 'os'].forEach(function (eye) {
      var cyl = self.sel('cyl', eye), axis = self.sel('axis', eye); if (!cyl || !axis) return;
      var needs = !!cyl.value && cyl.value !== '0.00';
      axis.classList.toggle('glassy-rx__select--needed', needs && (!axis.value || axis.value === '0'));
    });
  };

  /* ---- ADD → single-vision confirmation ----
     An ADD on the Rx means it was written for progressives/bifocals, which we
     don't make. Whenever either eye carries an ADD (from the auto-read or manual
     entry) a warning appears and the shopper must explicitly opt in to single
     vision before they can continue. */
  GlassyRx.prototype.hasAdd = function () {
    for (var i = 0; i < 2; i++) { var s = this.sel('add', i ? 'os' : 'od'); if (s && s.value && s.value !== '0.00') return true; }
    return false;
  };
  GlassyRx.prototype.addConfirmed = function () {
    if (!this.hasAdd()) return true;
    var c = this.root.querySelector('[data-rx-addwarn-check]');
    return !!(c && c.checked);
  };
  GlassyRx.prototype.updateAddWarning = function () {
    var w = this.root.querySelector('[data-rx-addwarn]'); if (!w) return;
    var has = this.hasAdd();
    // Reset when the ADD goes away so a re-appearing ADD needs a fresh confirmation.
    if (!has) { var c = w.querySelector('[data-rx-addwarn-check]'); if (c) c.checked = false; w.classList.remove('glassy-rx__addwarn--needed'); }
    w.hidden = !has;
  };

  /* ---- PD finder ---- */
  GlassyRx.prototype.openPdFinder = function () {
    var url = this.root.getAttribute('data-pd-finder-url');
    if (!this.pdModal || !this.pdFrame || !url) return;
    GlassyRx.activePdInstance = this;
    var frame = this.pdFrame;
    this.pdModal.hidden = false;
    document.documentElement.classList.add('glassy-rx-modal-open');
    // The finder is served from Shopify's asset CDN — a DIFFERENT origin than the
    // storefront. iOS Safari/WebKit blocks getUserMedia() inside a cross-origin
    // iframe, so the camera fails with NotAllowedError and never even prompts.
    // Load the finder's markup via srcdoc so it runs as a SAME-ORIGIN document,
    // where allow="camera" actually grants camera access. Fetch works because the
    // CDN serves theme assets with permissive CORS; if it ever fails we fall back
    // to the direct cross-origin src (unchanged behavior, fine on desktop).
    frame.removeAttribute('srcdoc');
    frame.src = 'about:blank';
    fetch(url, { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) { frame.removeAttribute('src'); frame.srcdoc = html; })
      .catch(function () { frame.removeAttribute('srcdoc'); frame.src = url; });
  };
  GlassyRx.prototype.closePdFinder = function () {
    if (this.pdModal) this.pdModal.hidden = true;
    // Drop srcdoc first, then blank the src — this tears down the finder document
    // (and releases the camera) regardless of which load path was used.
    if (this.pdFrame) { this.pdFrame.removeAttribute('srcdoc'); this.pdFrame.src = 'about:blank'; }
    document.documentElement.classList.remove('glassy-rx-modal-open');
  };
  GlassyRx.prototype.applyPd = function (pd) {
    var n = parseFloat(pd); if (isNaN(n) || n < 30 || n > 95) return;
    var el = this.root.querySelector('[data-rx-pd]'); if (el) { el.value = String(Math.round(n)); el.classList.remove('glassy-rx__pd-input--needed'); }
    this.closePdFinder(); this.updateReview(); this.updateNextState();
  };

  /* ---- Lens / price ---- */
  GlassyRx.prototype.selectedLens = function () { return this.root.querySelector('[data-rx-lens]:checked'); };
  GlassyRx.prototype.frameCents = function () { return parseInt(this.root.getAttribute('data-frame-price'), 10) || 0; };
  GlassyRx.prototype.lensCents = function () { var v = this.resolveVariant(); if (v) return v.price; var l = this.selectedLens(); return l ? (parseInt(l.getAttribute('data-rx-price'), 10) || 0) : 0; };
  GlassyRx.prototype.isOn = function () { return this.root.classList.contains('is-open'); };
  GlassyRx.prototype.toggleDrawer = function () { this.setOpen(!this.isOn()); };
  GlassyRx.prototype.setOpen = function (open) {
    this.root.classList.toggle('is-open', open);
    this.q('[data-rx-drawer]', function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (this.mode === 'optional') {
      // The native ATC (buy the frame as-is) stays visible while collapsed and is
      // swapped for the builder's own add-to-cart once the shopper opens it.
      this.setNativeHidden(open);
    } else {
      this.hidePaymentButton(open); this.pinSticky(open); this.syncStickyButton();
    }
    this.updateFileInput(); this.hideError(); this.updatePrice();
    if (open) this.goToStep(this.step);
  };
  GlassyRx.prototype.collectPriceTargets = function () {
    var targets = [], info = this.root.closest('.product__info');
    if (info) { var main = info.querySelector('.product-meta__price-list-container'); if (main) targets.push({ container: main, money: main.querySelector('.price:not(.price--compare) .money') || main.querySelector('.money') }); }
    // In optional mode the sticky bar keeps the NATIVE frame-only Add to Cart, so its
    // price must stay frame-only too — otherwise it would show the lens-inclusive total
    // next to a button that only adds the frame.
    if (this.mode !== 'optional') {
      var sticky = document.querySelector('.product-sticky-form__price'); if (sticky) targets.push({ container: sticky, money: sticky.querySelector('.money') || sticky });
    }
    targets.forEach(function (t) { if (t.money) t.origText = t.money.textContent; });
    return targets;
  };
  GlassyRx.prototype.updatePrice = function () {
    if (!this.priceTargets) return;
    var on = this.isOn(), total = this.frameCents() + (on ? this.lensCents() : 0), combined = money(total);
    this.priceTargets.forEach(function (t) {
      if (t.money) t.money.textContent = on ? combined : t.origText;
      var compare = t.container.querySelector('.price--compare'); if (compare) compare.style.display = on ? 'none' : '';
    });
    var lensEl = document.querySelector('[data-rx-sticky-lens]');
    if (lensEl) { var l = this.selectedLens(); if (this.mode !== 'optional' && on && l) { lensEl.textContent = l.getAttribute('data-rx-label') || ''; lensEl.hidden = false; } else { lensEl.textContent = ''; lensEl.hidden = true; } }
  };
  GlassyRx.prototype._onVariant = function (e) {
    var v = e && e.detail && e.detail.variant; if (v && typeof v.price === 'number') this.root.setAttribute('data-frame-price', v.price);
    var self = this;
    setTimeout(function () { if (!self.isOn() && self.priceTargets) self.priceTargets.forEach(function (t) { if (t.money) t.origText = t.money.textContent; }); self.updatePrice(); self.goToStep(self.step); }, 0);
  };
  GlassyRx.prototype.pinSticky = function (on) { var s = document.querySelector('.product-sticky-form'); if (s) s.classList.toggle('glassy-rx-pinned', on); };
  GlassyRx.prototype.updateFileInput = function () { var f = this.root.querySelector('[data-rx-file]'); if (f) f.disabled = !this.isOn(); };
  GlassyRx.prototype.hidePaymentButton = function (hide) {
    if (!this.form) return; var id = this.form.getAttribute('id'); if (!id) return;
    this.form.querySelectorAll('.shopify-payment-button').forEach(function (b) { b.style.display = hide ? 'none' : ''; });
    document.querySelectorAll('product-payment-container[form-id="' + id + '"] .shopify-payment-button').forEach(function (b) { b.style.display = hide ? 'none' : ''; });
  };
  // Optional mode: hide/show the WHOLE native buy-button container (Add to Cart +
  // dynamic checkout) so it doesn't compete with the builder's own add-to-cart.
  GlassyRx.prototype.setNativeHidden = function (hide) {
    if (!this.form) return;
    var wrap = this.form.closest('.product-form__buy-buttons');
    if (wrap) { var pc = wrap.querySelector('.product-form__payment-container'); if (pc) pc.style.display = hide ? 'none' : ''; }
    var id = this.form.getAttribute('id');
    if (id) document.querySelectorAll('product-payment-container[form-id="' + id + '"] .shopify-payment-button').forEach(function (b) { b.style.display = hide ? 'none' : ''; });
  };

  /* ---- Rx summary strings ---- */
  GlassyRx.prototype.eyeString = function (eye) {
    var self = this, get = function (k) { var el = self.sel(k, eye); return el ? el.value : ''; };
    var parts = [], sph = get('sph'); if (sph) parts.push('SPH ' + sph);
    var cyl = get('cyl'); if (cyl && cyl !== '0.00') parts.push('CYL ' + cyl);
    var axis = get('axis'); if (axis && axis !== '0') parts.push('Axis ' + axis);
    var add = get('add'); if (add && add !== '0.00') parts.push('Add ' + add);
    return parts.join(' / ');
  };
  GlassyRx.prototype.frameLabel = function () { var l = this.selectedLens(); return l ? (l.getAttribute('data-rx-label') || 'Prescription') : 'Prescription'; };
  GlassyRx.prototype.updateReview = function () {
    var ul = this.root.querySelector('[data-rx-review]'); if (!ul) return;
    var rows = [], lens = this.selectedLens();
    if (lens) {
      var rawPrice = lens.getAttribute('data-rx-price'), p = lens.getAttribute('data-rx-price-display') || '';
      if (rawPrice !== null && rawPrice !== '') p = addOnPrice(parseInt(rawPrice, 10) || 0);
      rows.push(['Lens', (lens.getAttribute('data-rx-label') || '') + (p ? ' (' + p + ')' : '')]);
    }
    var tl = this.thickLabel(); if (tl) { var td = this.thickDelta(this.selectedThick()); rows.push(['Thickness', tl + (td > 0 ? ' (+' + money(td) + ')' : '')]); }
    rows.push(['Right (OD)', this.eyeString('od') || '—']);
    rows.push(['Left (OS)', this.eyeString('os') || '—']);
    if (this.hasAdd()) rows.push(['Lens style', 'Single vision (confirmed)']);
    var pd = this.root.querySelector('[data-rx-pd]'); if (pd && pd.value.trim()) rows.push(['PD', pd.value.trim() + ' mm']);
    var file = this.root.querySelector('[data-rx-file]'), name = (file && file.files && file.files[0]) ? file.files[0].name : '';
    rows.push(['Prescription', name ? ('Photo: ' + name) : 'Entered manually']);
    var html = '';
    rows.forEach(function (r) { html += '<li><span>' + escapeHtml(r[0]) + '</span><span>' + escapeHtml(r[1]) + '</span></li>'; });
    html += '<li class="glassy-rx__rev-tot"><span>Total</span><span>' + escapeHtml(money(this.frameCents() + this.lensCents())) + '</span></li>';
    ul.innerHTML = html;
  };

  /* ---- Errors ---- */
  GlassyRx.prototype.showError = function (msg) { this.q('[data-rx-error]', function (e) { e.textContent = msg; e.classList.add('is-visible'); }); };
  GlassyRx.prototype.hideError = function () { this.q('[data-rx-error]', function (e) { e.classList.remove('is-visible'); }); };

  /* ---- Cart add (preserved) ---- */
  GlassyRx.prototype.rxProperties = function (groupId) {
    var props = {}, lens = this.selectedLens();
    if (lens) props['Lens'] = lens.getAttribute('data-rx-label') || '';
    var tl = this.thickLabel(); if (tl) props['Lens thickness'] = tl;
    var od = this.eyeString('od'), os = this.eyeString('os'), pd = this.root.querySelector('[data-rx-pd]');
    if (od) props['Rx — Right (OD)'] = od;
    if (os) props['Rx — Left (OS)'] = os;
    if (this.hasAdd()) props['Single vision confirmed'] = 'Yes — Rx has an ADD';
    if (pd && pd.value.trim()) props['PD'] = pd.value.trim();
    var file = this.root.querySelector('[data-rx-file]');
    props['Prescription'] = (file && file.files && file.files.length) ? 'Uploaded with order' : 'Entered manually';
    var frameName = this.root.getAttribute('data-frame-title') || ''; if (frameName) props['For frame'] = frameName;
    props['_rx_group'] = groupId;
    return props;
  };
  GlassyRx.prototype.companionVariantId = function () { var v = this.resolveVariant(); if (v && v.id) return v.id; var l = this.selectedLens(), id = l && l.getAttribute('data-rx-variant'); return id ? parseInt(id, 10) : null; };
  GlassyRx.prototype.frameVariantId = function () { var i = this.form && this.form.querySelector('[name="id"]'); return i ? parseInt(i.value, 10) : null; };
  GlassyRx.prototype.frameQuantity = function () { var q = this.form && this.form.querySelector('[name="quantity"]'), v = q ? parseInt(q.value, 10) : 1; return v > 0 ? v : 1; };
  GlassyRx.prototype.submitButtons = function () {
    var list = []; if (this.form) Array.prototype.push.apply(list, this.form.querySelectorAll('[type="submit"]'));
    var fid = this.form && this.form.getAttribute('id'); if (fid) document.querySelectorAll('[form="' + fid + '"][type="submit"]').forEach(function (b) { list.push(b); });
    return list;
  };
  GlassyRx.prototype.setBusy = function (busy) {
    this.q('[data-rx-next]', function (b) {
      b.disabled = busy;
      if (busy) { b.setAttribute('data-label', b.textContent); b.textContent = 'Adding…'; }
      else if (b.getAttribute('data-label')) { b.textContent = b.getAttribute('data-label'); }
    });
    this.submitButtons().forEach(function (b) { if (busy) b.setAttribute('disabled', 'disabled'); else b.removeAttribute('disabled'); });
  };
  GlassyRx.prototype.addToCart = function () {
    var groupId = 'rx-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
    if (!this.frameVariantId()) { this.showError('Please select an available option before adding to cart.'); return Promise.resolve(); }
    return this.addViaForm(groupId, this.frameQuantity());
  };
  GlassyRx.prototype.addViaForm = function (groupId, qty) {
    var self = this, companionId = this.companionVariantId(), rxProps = this.rxProperties(groupId);
    var fd = new FormData(this.form);
    fd.set('id', this.frameVariantId()); fd.set('quantity', qty); fd.set('properties[_rx_group]', groupId);
    if (!companionId) fd.set('properties[Prescription]', this.frameLabel());
    if (!isPageCart()) fd.append('sections', 'mini-cart');
    this.hideError();
    return fetch(cartAddUrl(), { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (res) { return res.json().then(function (j) { return { ok: res.ok, json: j }; }); })
      .then(function (frameRes) {
        if (!frameRes.ok) { self.showError((frameRes.json && frameRes.json.description) || 'We couldn’t add your frame. Try a smaller photo or a different format.'); return; }
        if (!companionId) { self.afterAdd(frameRes.json); return; }
        return fetch(cartAddUrl(), { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: companionId, quantity: qty, properties: rxProps }], sections: isPageCart() ? undefined : ['mini-cart'] }) })
          .then(function (res2) { return res2.json().then(function (j2) { return { ok: res2.ok, json: j2 }; }); })
          .then(function (compRes) { if (!compRes.ok) self.showError('Your frame added, but the lens line failed — please contact us.'); self.afterAdd(compRes.json); });
      })
      .catch(function () { self.showError('Something went wrong adding to your cart. Please try again.'); });
  };
  GlassyRx.prototype.afterAdd = function (addJson) {
    if (isPageCart()) { window.location.href = root() + 'cart'; return; }
    var self = this;
    fetch(cartUrl()).then(function (res) { return res.json(); }).then(function (cart) {
      if (addJson && addJson.sections) cart.sections = addJson.sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: cartType() === 'drawer' } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', { bubbles: true, cancelable: true, detail: { status: 'success', error: '' } }));
    }).catch(function () { });
  };

  /* ---- Wiring ---- */
  var registry = [];
  function register(el) { if (el.__glassyRx) return; el.__glassyRx = new GlassyRx(el); registry.push(el.__glassyRx); }
  GlassyRx.activePdInstance = null;
  window.addEventListener('message', function (e) { if (!e.data || e.data.type !== 'glassy-pd') return; var inst = GlassyRx.activePdInstance; if (inst) inst.applyPd(e.data.pd); });
  // A file dropped anywhere OTHER than the zone would make the browser open it and
  // navigate away (losing the shopper's progress). Swallow those stray drops.
  ['dragover', 'drop'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-rx-dropzone]')) return;
      e.preventDefault();
    });
  });

  function boot() { document.querySelectorAll('.glassy-rx').forEach(register); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
